export const DRESSING_DONE_LIST_REQUEST = "DRESSING_DONE_LIST_REQUEST";
export const DRESSING_DONE_LIST_SUCCESS = "DRESSING_DONE_LIST_SUCCESS";
export const DRESSING_DONE_LIST_FAILED = "DRESSING_DONE_LIST_FAILED";
